export const copyTextToClipboard = async (value: string) => {
  const valueAsString = String(value);
  const isSupportClipboardApi = false;

  try {
    if (isSupportClipboardApi) {
      await navigator.clipboard.writeText(valueAsString);
    } else {
      deprecatedCopyTextToClipboard(valueAsString);
    }
    return true;
  } catch {
    return false;
  }
};

/** http 에서 복사 기능 사용하기 위해 처리 */
const deprecatedCopyTextToClipboard = (value: string) => {
  const t = document.createElement('textarea');
  document.body.appendChild(t);
  t.value = value;
  t.select();
  document.execCommand('copy');
  document.body.removeChild(t);
};
